// 无尽塔 设定

import { TowerTabType } from "./towerType";

const towerTab: TowerTabType[] = [
  {
    id: 1,
    name: "雷雷塔",
    monsterIds: [0, 0, 1, 1, 2],
    currentLevel: 1,
    describe: "哥布林王—雷雷的**",
    value: 1
  },
  {
    id: 2,
    name: "喵喵塔",
    monsterIds: [4, 4, 5, 6, 7],
    currentLevel: 1,
    describe: "",
    value: 2
  }
  // {
  //   id: 3,
  //   name: "龙人塔",
  //   monsterIds: [3],
  //   currentLevel: 1,
  //   describe: "",
  //   value: 3
  // }
];
const towerTabMap = new Map();
towerTab.forEach(m => {
  towerTabMap.set(m.name, m);
});
export { towerTab, towerTabMap };
